// extracted by mini-css-extract-plugin
export default {"task":"TasksInPipeline_task__bYR4z","taskParent":"TasksInPipeline_taskParent__gW7qU","icon":"TasksInPipeline_icon__xINWP"};